import React, { useEffect, useRef } from "react";
import { QrReader } from "react-qr-reader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CheckInQr = ({ onScan, bannerText, showCancel }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const containerRef = useRef();
  const handleExit = () => {
    navigate(t(`urls.store_check_in`));
  };

  const handleScanResult = (result) => {
    if (result) {
      if (onScan) {
        onScan(result);
        return;
      }

      if (result.text.match(/^TB-\d{13}-\d{6}$/i)) {
        navigate(`${t("urls.store_trade_in_start")}?id=${result?.text}`);
        navigate(0);
      } else {
        alert(
          "Please ensure you scan a sellers QR code and not other codes such as the kiosk weight"
        );
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        containerRef.current.style.height = `${window.innerHeight}px`;
        containerRef.current.style.width = `${window.innerWidth}px`;
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex flex-col w-full h-full max-w-screen max-h-screen overflow-hidden relative border-4 border-transparent"
    >
      <button
        onClick={handleExit}
        className="absolute top-4 right-4 bg-black text-white rounded-full w-8 h-8 flex items-center justify-center z-10"
      >
        ✕
      </button>
      <QrReader
        constraints={{
          facingMode: "environment",
        }}
        containerStyle={{
          width: "100%",
          height: "100%",
        }}
        videoContainerStyle={{
          width: "100%",
          height: "100%",
        }}
        videoStyle={{
          width: "100%",
          height: "100%",
        }}
        onResult={handleScanResult}
      />
      <div className="absolute bottom-0 w-full flex flex-col items-center bg-black bg-opacity-50 py-8">
        <div className="text-white text-center font-bold text-2xl mb-6">
          {bannerText || t(`store.check-in.scan-qr`)}
        </div>

        <button
          onClick={handleExit}
          className="bg-white rounded-full px-12 py-3 text-lg font-medium shadow-md focus:outline-none"
          style={{ minWidth: 200 }}
        >
          <span className="text-black">{t("ui.button_cancel")}</span>
        </button>
      </div>
    </div>
  );
};

export default CheckInQr;
